import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { ColorProvider, Image, ShadowBox } from '../components';

const Container = styled(ShadowBox)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacings.mega};
`;
const PrizeContainer = styled.div`
  display: flex;
  justify-content: right;
`;

const pointHeaderBaseStyles = ({ theme }) => css`
  display: flex;
  flex: 1;
  align-items: center;
  padding: ${theme.spacings.kilo} 0 0;
  text-align: center;
  font-family: ${theme.fontStack.bold.name};
`;

const PointHeaderContainer = styled('div')(pointHeaderBaseStyles);

const PointNumber = styled.span`
  display: block;
  font-size: 50px;
  line-height: 40px;
  letter-spacing: -1px;
  text-align: left;
  min-width: 60px;
`;

const pointTextBaseStyles = ({ theme }) => css`
  font-size: ${theme.typography.text.exa.fontSize};
  line-height: 20px;
  letter-spacing: -0.5px;
  padding-left: ${theme.spacings.bit};
  text-align: left;
  span {
    color: ${theme.colors.n900};
  }
`;
const PointText = styled('span')(pointTextBaseStyles);

const prizeDotGroupBaseStyles = ({ theme }) => css`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacings.kilo};
`;

const PrizeDotGroup = styled('div')(prizeDotGroupBaseStyles);

const prizeDotBaseStyles = ({ theme }) => css`
  padding: ${theme.spacings.byte};
`;

const PrizeDot = styled('div')(prizeDotBaseStyles);

const prizeDescStyles = ({ theme }) => css`
  font-size: ${theme.typography.text.mega.fontSize};
  letter-spacing: -0.1px;
  text-align: center;

  span {
    display: block;
    font-family: ${theme.fontStack.bold.name};
    color: ${theme.colors.r500};
  }
`;

const PrizeDesc = styled.span(prizeDescStyles);

const RewardItem = ({ level, instructionText, rewardText, points, isOffer, orText, offerText, anText, pointsText }) => (
  <Container>
    <ColorProvider variant='red'>
      <PrizeContainer>
        <PointHeaderContainer>
          <PointNumber>{points}</PointNumber>
          <PointText size='exa' bold centered noMargin>
            {pointsText}{' '}
            {isOffer && (
              <>
                <span>
                  {' '}
                  {orText} {anText}
                </span>
                &nbsp;{offerText}
              </>
            )}
          </PointText>
        </PointHeaderContainer>
        <PrizeDotGroup>
          {[0, 1, 2].map((num, index) => (
            <PrizeDot key={index}>
              <Image
                src={`https://cdn.rbi.digital/hockey/${
                  num <= level ? 'img_player_active1.png' : 'img_player_inactive1.png'
                }`}
              />
            </PrizeDot>
          ))}
        </PrizeDotGroup>
      </PrizeContainer>
    </ColorProvider>
    <PrizeDesc>
      {instructionText}
      <span>{rewardText}</span>
    </PrizeDesc>
  </Container>
);

RewardItem.propTypes = {
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  level: PropTypes.number,
  instructionText: PropTypes.string,
  rewardText: PropTypes.string,
  points: PropTypes.number,
  isOffer: PropTypes.bool,
  orText: PropTypes.string,
  offerText: PropTypes.string,
  pointsText: PropTypes.string,
};

export default RewardItem;
